/**
 * Locale-aware compact volume amounts (#874): USD stays USD ("$1.2M"); separators, $ placement and the unit letters
 * follow the active locale (docs/I18N.md "Formatting"). The scaling rules live in volume.ts compactParts (shared with
 * Android and iOS through shared/fixtures/volume.json).
 */
import { localizeNumber, usdCompact } from '../i18n/format';
import { t, type PlainKey } from '../i18n/i18n';
import { compactParts, type CompactUnit } from './volume';

const UNIT_KEYS: Record<Exclude<CompactUnit, ''>, PlainKey> = {
  k: 'volume.unit.thousand',
  m: 'volume.unit.million',
  b: 'volume.unit.billion',
  t: 'volume.unit.trillion',
};

function unitText(u: CompactUnit): string {
  return u === '' ? '' : t(UNIT_KEYS[u]);
}

/** 1234567 -> "$1.2M" (en), "$ 1,2M" (pt-BR); "—" for a missing / invalid amount. */
export function formatVolumeUsd(n: number | undefined): string {
  const p = n === undefined ? null : compactParts(n);
  return p ? usdCompact(p.mantissa, unitText(p.unit)) : '—';
}

/** 15412 -> "15.4K" (contracts); "—" for a missing / invalid amount. */
export function formatVolumeCount(n: number | undefined): string {
  const p = n === undefined ? null : compactParts(n);
  return p ? `${localizeNumber(p.mantissa)}${unitText(p.unit)}` : '—';
}
